<template>
    <UPopover
        mode="click"
        :content="{
            side: 'bottom',
            align: 'center',
            sideOffset: 34,
            alignOffset: 0,
            avoidCollisions: true,
            collisionPadding: 18,
        }"
        :ui="{
            content:
                'shadow-none !shadow-(--shadow-drop-shadow-lg) w-[90vw] max-w-98 bg-(--ui-bg) ring-0 ring-default-0 border-(--ui-border) text-(--ui-text-primary) rounded ',
        }"
    >
        <slot name="trigger">
            <UButton
                icon="i-lucide:circle-user-round"
                size="xl"
                variant="ghost"
                :ui="{ base: 'cursor-pointer text-(--ui-text-white)' }"
            />
        </slot>

        <template #content>
            <div>
                <!-- Greeting Section -->
                <div
                    class="text-(--ui-text-primary) px-6 py-6 border-b border-(--ui-bg-neutral-elevated) bg-(--ui-bg-neutral-elevated) rounded-t"
                >
                    <p class="font-serif text-3xl text-(--ui-text-primary) font-semibold">
                        {{ customerAuth ? 'Hi, ' + customName : 'Welcome to Crane' }}
                    </p>
                </div>

                <!-- Menu Items Section -->
                <div class="p-6 text-(--ui-text-primary)">
                    <!-- TK-10681: account CTA hidden for Alpha when HIDE_FOR_ALPHA; Sign In / Log Out stay. -->
                    <template v-if="!HIDE_FOR_ALPHA">
                        <UButton
                            variant="link"
                            block
                            class="w-full justify-start gap-2.5 pb-5 text-md font-medium rounded"
                            :ui="{
                                base: 'text-(--ui-text-primary) cursor-pointer font-medium underline decoration-solid',
                            }"
                            @click="customerAuth ? handleMyAccount() : handleSignup()"
                        >
                            <UIcon
                                name="i-lucide:circle-user-round"
                                class="w-6 h-6 shrink-0 stroke-2"
                            />
                            {{ customerAuth ? 'Manage My Account' : 'Create Account' }}
                        </UButton>

                        <div class="border-t border-(--ui-border) h-px" role="separator" />
                    </template>

                    <UButton
                        variant="link"
                        block
                        class="w-full justify-start gap-2 pt-5 text-md font-medium"
                        :ui="{
                            base: 'text-(--ui-text-primary) cursor-pointer font-medium underline decoration-solid',
                        }"
                        @click="customerAuth ? handleLogout() : handleLogin()"
                    >
                        <UIcon
                            name="i-ic:baseline-arrow-forward"
                            class="w-6 h-6 shrink-0 stroke-2"
                        />
                        {{ customerAuth ? 'Log Out' : 'Sign In' }}
                    </UButton>
                </div>
            </div>
        </template>
    </UPopover>
</template>

<script setup lang="ts">
import { HIDE_FOR_ALPHA } from '~~/layers/base/constants/hideForAlpha'
import { AuthView } from '~~/layers/base/types/auth'

const emit = defineEmits<{
    (e: 'redirect-to-my-account'): void
}>()

const { open } = useAuthFlow()
const customerAuthStore = useCustomerAuthAccsStore()
const customerStore = useCustomerStore()

// reactive value from store

const { customerAuth } = storeToRefs(customerAuthStore)
const { customer } = storeToRefs(customerStore) // Ref<Customer | null>
const customName = computed(() => {
    if (customer.value) {
        return `${customer.value?.firstName} ${customer.value.lastName}`
    }
    return 'Guest'
})

const handleLogout = () => {
    customerAuthStore.logout()
    customer.value = null
}
const handleLogin = () => {
    open(AuthView.Login)
}
const handleSignup = () => {
    open(AuthView.SignUp)
}
const handleMyAccount = () => {
    emit('redirect-to-my-account')
}
</script>

<style scoped>
:deep(button:focus-visible) {
    outline: none !important;
}
</style>
